import React                   from 'react'
import AutoComplete from './AutoComplete'

class AutoCompleteSearch extends React.PureComponent {
  render() {
    return (
      <div className={`form-group has-search ${this.props.className}`}>
        <AutoComplete {...this.props} placeholder={this.props.placeholder} isFocused={true} />
      </div>
    );
  }
}

export default AutoCompleteSearch
